import { useEffect } from "react";
import Layout from "./components/Layout/Layout";

function App() {
  useEffect(() => {
    const handlePhoneClick = (e) => {
      // e.composedPath() preserves the full element chain up to window
      const path = e.composedPath ? e.composedPath() : [];
      
      const callAnchor = path.find(
        (el) => el instanceof HTMLElement && el.matches('a[href^="tel:"]')
      ) || e.target.closest('a[href^="tel:"]');

      if (callAnchor && window.ttq) {
        window.ttq.track('Contact', {
          contents: [
            {
              content_name: 'Phone Call Lead',
              content_type: 'product'
            }
          ],
          value: 0,
          currency: 'EUR'
        });
      }
    };

    document.addEventListener('click', handlePhoneClick);
    return () => document.removeEventListener('click', handlePhoneClick);
  }, []);

  return <Layout />;
}

export default App;